import React,{ useState } from "react";
import { useDispatch } from "react-redux";
import { exportTasks } from "actions";
import { Excel } from "CommonComponent";
import  Filter  from "../Filter";

const Header = ({onFilter, extraFiltersState, setExtraFiltersState, handleExport}) => {

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">Daily ACD</h1>
          <div className="d-flex gap-3">
            <Excel handleExport={handleExport} />
          </div> 
        </div>
      </div>
    </>
  );
};

export default Header;
